/* global axios */
import ApiClient from './ApiClient';

class ReportingOverridesAPI extends ApiClient {
  constructor() {
    super('reporting_overrides', { accountScoped: true, apiVersion: 'v2' });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, { override: payload });
  }

  revoke(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ReportingOverridesAPI();
